export default "__VITE_ASSET__Drk56qli__"